export default __webpack_public_path__ + "static/media/DSC06125.1a6ba45c.jpg";